import React from "react";

export const AdminContext = React.createContext({
    companies: undefined,
    setCompanies: () => {},

    companiesToAccept: undefined,
    setCompaniesToAccept: () => {},
});